import FilledButton from "@/components/button/filled-button";
import { FullScreenBackgroundContainer } from "@/components/container/full-screen-background-container";
import { QueryKeys } from "@/constants/query-keys";
import { useMarkOnboardCompleted } from "@/hooks/requests/user/use-mark-onboard-completed";
import { useIonRouter } from "@ionic/react";
import { useQueryClient } from "@tanstack/react-query";

const ProfilingWelcomePage = () => {
  const navigation = useIonRouter();
  const { isPending, markOnboardCompleted } = useMarkOnboardCompleted();
  const queryClient = useQueryClient();

  const handleEnterNutriCoach = () => {
    markOnboardCompleted(undefined, {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: [QueryKeys.USER] }),
          queryClient.invalidateQueries({ queryKey: [QueryKeys.SUBSCRIPTION_STATUS] }),
        ]);
        navigation.push("/plans/my-plan", "none");
      },
    });
  };
  return (
    <FullScreenBackgroundContainer imageClassName="bg-[url(/assets/images/nutricoach-welcome-screen-2.jpg)]">
      <div className="flex flex-1 flex-col items-center justify-center gap-4 text-white">
        <h2 className="text-center font-bold">Welcome to NutriCoach!</h2>
        <p className="text-center">
          Your nutrition companion, designed to fit around your unique lifestyle
        </p>
      </div>

      <div className="flex w-full justify-center">
        <FilledButton
          text="Enter NutriCoach"
          onClick={handleEnterNutriCoach}
          disabled={isPending}
        />
      </div>
    </FullScreenBackgroundContainer>
  );
};

export default ProfilingWelcomePage;
